import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';

const devUrl = environment.backendurl

@Injectable({
  providedIn: 'root'
})
export class EmailIntegrationService {

  constructor(private http: HttpClient) { }

  public integratedEmailData: Subject<any> = new Subject(); 
  //get fetchintegratedemails
  fetchintegratedemails() {
    let url = devUrl + "/user/fetchintegratedemails"
    return this.http.get(url).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('fetchintegratedemails ', url)))
  }

  gmailintegrationurl(data) {
    let url = devUrl + "/user/gmailintegrationurl";
    return this.http.post(url, data).pipe(
      map(response => { return response }),
      catchError(GlobalService.handleError('gmailintegrationurl', url))
    )
  }

  outlookintegrationurl(data) {
    let url = devUrl + "/user/outlookintegrationurl";
    return this.http.post(url, data).pipe(
      map(response => { return response }),
      catchError(GlobalService.handleError('outlookintegrationurl', url))
    )
  }

  savegmaildetails(data) {
    let url = devUrl + "/user/savegmaildetails";
    return this.http.post(url, data).pipe(
      map(response => { return response }),
      catchError(GlobalService.handleError('savegmaildetails', url))
    )
  }

  saveoutlookdetails(data) {
    let url = devUrl + "/user/saveoutlookdetails";
    return this.http.post(url, data).pipe(
      map(response => { return response }),
      catchError(GlobalService.handleError('saveoutlookdetails', url))
    )
  }

  disconnectemail(data) {
    let url = devUrl + "/user/disconnectemail";
    return this.http.post(url, data).pipe(
      map(response => { return response }),
      catchError(GlobalService.handleError('disconnectemail', url))
    )
  }


  public passIntergratedEmailData (data): void {
    console.log(data , "Data here")
    this.integratedEmailData.next(data);
  }
  
  public getIntergratedEmailData (): Observable<any> {
    return this.integratedEmailData.asObservable();
  }


}
